<div
  class="block w-full sm:w-80 bg-surface dark:bg-surface-darkmode overflow-hidden rounded-md shadow-md border border-outline dark:border-outline-darkmode"
>
  <ng-content />
</div>
